var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircularCurrent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0526 35L42.0214 36.6187L40.853 38.1413L39.5564 39.5564L38.1413 40.853L36.6187 42.0214L35 43.0526L33.2976 43.9388L31.5244 44.6732L29.694 45.2504L27.8203 45.6658L25.9174 45.9163L24 46L22.0826 45.9163L20.1797 45.6658L18.306 45.2504L16.4756 44.6732L14.7024 43.9388L13 43.0526L11.3813 42.0214L9.85867 40.853L8.44365 39.5564L7.14702 38.1413L5.97865 36.6187L4.94744 35L4.06123 33.2976L3.32676 31.5244L2.74963 29.694L2.33423 27.8203L2.08372 25.9174L2 24L2.08372 22.0826L2.33423 20.1797L2.74963 18.306L3.32676 16.4756L4.06123 14.7024L4.94744 13L5.97865 11.3813L7.14702 9.85867L8.44365 8.44365L9.85867 7.14702L11.3813 5.97865L13 4.94744L14.7024 4.06123L16.4756 3.32676L18.306 2.74963L20.1797 2.33423",
    stroke: "#ACF2C8",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8203 2.33423L29.6941 2.74963L31.5245 3.32676L33.2977 4.06123L35.0001 4.94744L36.6187 5.97865L38.1414 7.14702L39.5564 8.44365L40.853 9.85867L42.0214 11.3813L43.0526 13L43.9388 14.7024L44.6733 16.4756L45.2504 18.306L45.6658 20.1797L45.9163 22.0826L46.0001 24L45.9163 25.9174L45.6658 27.8203",
    stroke: "#266A4A",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularCurrent);
export default __webpack_public_path__ + "static/media/circular-current.6a634991fb50d3540067e6fd75b59184.svg";
export { ForwardRef as ReactComponent };